<template>
	<div class="login">
		<login-register>
			<login-form />
		</login-register>
		<div class="text-box">
			津公网安备 <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=12011602001507" target="_blank">12011602001507号</a>&nbsp;<a href="https://beian.miit.gov.cn/" target="_blank">津ICP备16006392号-3</a> 版权所有 天津市风行科技信息工程有限公司 1998-2025
		</div>
	</div>
</template>
<script>
import LoginRegister from '@/components/LoginRegister.vue'
import LoginForm from '@/components/login/LoginForm.vue'
export default {
	name: 'lgoin',
	components: {
		LoginRegister,
		LoginForm
	}
}
</script>
<style lang="stylus" scoped>
.login {
	display flex
	flex: 1
}
.text-box{
	position: absolute;
	bottom: 10px;
	width: 100%;
	color: #e0e0e0
}
</style>
